// extracted by mini-css-extract-plugin
export default {"titleContainer":"_3mNC6IWe","centeredWhite":"_1YZYU_sb","leftAligned":"aP-dQM0D","hasIcon":"Y46z1DZh","gray":"_1UwlefAI","green":"_3ZB-s3c3","iconContainer":"M-iiHrtX"};